<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">

            <!-- Brand logo-->
            <b-link class="brand-logo">
                <vuexy-logo />
                <h2 class="brand-text text-primary ml-1">TMS</h2>
            </b-link>
            <!-- /Brand logo-->

            <!-- Left Text-->
            <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <b-img fluid class="login-img" :src="sideImg" alt="Login V2"/>
                </div>
            </b-col>
            <!-- /Left Text-->

            <!-- Login-->
            <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
                <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
                    <b-card-title title-tag="h2" class="font-weight-bold mb-1">
                        Şifremi Unuttum 😔
                    </b-card-title>
                    <b-card-text class="mb-2">
                        Şifrenizi yeniden oluşturmak için e-posta giriniz.
                    </b-card-text>

                <!-- form -->
                
                    <b-form class="auth-login-form mt-2" @submit.prevent>
                        <!-- email -->
                        <b-form-group label="E-Posta" label-for="login-email">
                            <b-form-input id="forgot-email" autocomplete="nope" role="presentation" v-model="email" :name="Date.now().toString()" placeholder="john@example.com"/>
                        </b-form-group>

                        <b-button :disabled="!ready || loading" type="submit" variant="primary" class="d-flex align-items-center justify-content-center" block v-on:click="submit">
                            <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                            Gönder
                        </b-button>
                    </b-form>
                </b-col>
            </b-col>
        <!-- /Login-->
        </b-row>
    </div>
</template>

<script>
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner} from 'bootstrap-vue'
import AuthApi from '@/api/auth'

export default {
    components: {
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BFormCheckbox,
        BCardText,
        BCardTitle,
        BImg,
        BForm,
        BButton,
        BSpinner,
        VuexyLogo,
    },
    data() {
        return {
            status: '',
            email: '',
            sideImg: require('@/assets/images/pages/forgot-password.svg'),
            loading:false,
        }
    },
    computed:{
        ready(){
            return this.email && this.email?.trim()
        }
    },
    mounted(){
        this.email = null
    },
    methods: {
        submit() {  
            this.loading = true
            if(this.email){
                AuthApi.ForgotPassword(this.email).then(res=>{
                    this.loading = false
                    this.$result(res)
                    if(res.data.Success){
                        this.$router.push({name:"login"})
                    }
                }).catch(err=>{
                    this.loading = false
                    this$result(null,err)
                })
            }   
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
